import api_url from "./api_url";


export const createPost = async (postData) => {
    try {
        const response = await fetch(`${api_url}/api/events_news`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            body: JSON.stringify(postData),
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || "Failed to create post");
        }

        return { success: true, data };
    } catch (error) {
        return { success: false, message: error.message };
    }
};